import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/services/language.service';
import { OpenContractService } from 'src/app/shared/services/open-contract.service';
import { FetchContractDataService } from '../../services/fetch-contract-data.service';
import { BusinessContractDataComponent } from './business-contract-data/business-contract-data.component';
import { ContractDeliveryAddressComponent } from './contract-delivery-address/contract-delivery-address.component';

@Component({
  selector: 'app-new-contract-page',
  templateUrl: './new-contract-page.component.html',
  styleUrls: ['./new-contract-page.component.scss']
})
export class NewContractPageComponent implements OnInit {
  @ViewChild(ContractDeliveryAddressComponent)
  contractDeliveryComp: ContractDeliveryAddressComponent;
  @ViewChild(BusinessContractDataComponent)
  businessContractData: BusinessContractDataComponent;
  lang;
  constructor(
    private fetchContractData: FetchContractDataService,
    private translate: TranslateService,
    private languageService:LanguageService,
    public openContractService: OpenContractService,
  ) { }
  async ngOnInit() {
    this.translate.use(localStorage.getItem('language'));
    this.lang=this.translate.currentLang;
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
      this.lang=lang;
    });
    const oldContractData = await this.fetchContractData.make();
    this.businessContractData.initForms(oldContractData);
    this.contractDeliveryComp.initFormValues(oldContractData);
  }
  toggleActivationStep(){
    this.openContractService.contractStatus = !this.openContractService.contractStatus;
  }
}
